import { Trans } from "react-i18next";import { AppLayout, PageBackLink } from "../../../components/layout";

// Absolute path this module's Org Chart page lives at.
const ORG_CHART_PATH = "/hrms-ess/org-chart";

// =============================================================================
// UnassignedPage.jsx — lists everyone whose "manager" (reporting-to) field is
// empty. These people do NOT appear as a card anywhere in the Org Chart tree,
// because a card can only be drawn under its manager.
//
// TODO: this page has no data source right now. The real backend's hierarchy
// endpoint (see utils/orgApi.js) is scoped to one employee's chain at a time —
// it can't answer "who across the whole company has no manager". Wire this
// page up once a dedicated endpoint for that exists; until then it just
// explains why the list is empty instead of guessing.
// =============================================================================
export default function UnassignedPage() {
  return (
    <AppLayout>
      <PageBackLink to={ORG_CHART_PATH} />

      <div className="mb-6">
        <h1 className="m-0 mb-1 text-xl md:text-[26px] font-bold text-foreground uppercase tracking-[0.03em]">
          <Trans i18nKey="orgCharts.unassignedEmployees" />
        </h1>
      </div>

      <div className="max-w-[560px] bg-white border border-slate-200 rounded-[10px] px-5 py-4 text-sm text-muted-foreground">
        <Trans i18nKey="orgCharts.thisListIsnTAvailableYetItNeeds" />
      


      </div>
    </AppLayout>);

}
